import type { MetaInfoState } from '@sravni/react-silent-authentication-form/dist/types/components/ContextProvider/components/MetainfoProvider';

export const AuthFormConfig = {
  texts: {
    consentsScreenTitle: 'Подтвердите согласие на получение выгодных предложений и информации',
    bannerTitle: 'Кредит на Сравни',
    bannerAdsTextsList: [
      'Максимально точные условия',
      'Предложения от топовых банков',
      'Полная картина на рынке кредитов',
    ],
    advertisingCheckboxLabel: 'Даю согласие на получение {link|рекламы} и информационных сообщений',
  },
  metaInfo: {
    authCodeChannel: 'Sms',
    source: 'Новая анкета подбора кредита',
    customer: 'creditselection-frontend-v2',
    productName: 'Новый Подбор кредита',
  } as MetaInfoState,
};
